import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import axiosHttp from "../config/axios.interceptor";
import {
  filterReducerConstant,
  utilReducerConstant,
} from "../store/reducerConstant";
import Multiselect from "multiselect-react-dropdown";
import RangeSlider from "./RangeSlider";
import { numberWithCommas } from "../../utils/application-helper";
import { errorResponseMessage } from "../shared/const.prop";
import { AppContext } from "../contexts/AppContext";
import { getFilterList } from "../store/actions/filterActions";

const Filter = () => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const {
    utilData: { stateList = [], categoryList = [] },
    filterData,
  } = useSelector((state) => state);
  const [filter, setFilter] = useState({
    categories: filterData.categories || [],
    isSingle: filterData.isSingle,
    singleAmount:
      filterData.singleAmount.length === 0
        ? [0, 100000]
        : filterData.singleAmount,
    isWeekly: filterData.isWeekly,
    weeklyAmount:
      filterData.weeklyAmount.length === 0
        ? [0, 100000]
        : filterData.weeklyAmount,
    isMonthly: filterData.isMonthly,
    monthlyAmount:
      filterData.monthlyAmount.length === 0
        ? [0, 100000]
        : filterData.monthlyAmount,
    state: filterData.state || [],
    page: filterData.page || 1,
    lastPage: filterData.lastPage || 1,
  });

  useEffect(() => {
    fetchStates();
  }, []);

  const fetchStates = async () => {
    try {
      const newStateList = await axiosHttp.get(`states?country_id=101`);
      dispatch({
        type: utilReducerConstant.SET_STATE_LIST,
        payload: newStateList?.data?.data || [],
      });
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const buildParams = () => {
    let params = {};
    let states = [];
    let categories = [];

    if (filter.categories.length > 0) {
      filter.categories.map((item) => {
        categories.push(`${item?._id}`);
      });
    }

    if (filter.isSingle) {
      params.singleStart = filter.singleAmount[0];
      params.singleEnd = filter.singleAmount[1];
    }

    if (filter.isWeekly) {
      params.weeklyStart = filter.weeklyAmount[0];
      params.weeklyEnd = filter.weeklyAmount[1];
    }

    if (filter.isMonthly) {
      params.monthlyStart = filter.monthlyAmount[0];
      params.monthlyEnd = filter.monthlyAmount[1];
    }

    if (filter.state.length > 0) {
      filter.state.map((item) => {
        states.push(`${item?.id}`);
      });
    }

    if (categories.length !== 0) {
      params.categories = categories;
    }

    if (states.length !== 0) {
      params.states = states;
    }

    params.page = 1;

    return params;
  };

  const successCallback = (val) => {
    console.log(val);
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const fetchFilterData = async () => {
    const params = buildParams();
    try {
      const resp = await axiosHttp.get(`mentor-advance-search`, {
        params,
      });
      if (resp?.status === 200) {
        dispatch({
          type: filterReducerConstant.UPDATE_FILTER_LIST,
          payload: {
            ...filter,
            filterList: resp?.data?.data,
            currentPage: resp?.data?.meta?.currentPage,
            lastPage: resp?.data?.meta?.lastPage,
          },
        });
        appContext.updateModalState();
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }

      appContext.updateModalState();
    }
  };

  const updateAmount = (key, values) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      [key]: values,
    }));
  };

  return (
    <div>
      <div className="modal-body">
        <div className="filter-cat">
          <h3>Location (India)</h3>
          <div className="form-group input-group mt-2">
            <label className="has-float-label">
              <Multiselect
                options={stateList}
                hidePlaceholder={true}
                closeOnSelect={false}
                onSelect={(val) => setFilter({ ...filter, state: val })}
                onRemove={(val) => setFilter({ ...filter, state: val })}
                selectedValues={filterData.states}
                displayValue="name"
                className="multi-select-wrapper"
              />
            </label>
          </div>
        </div>

        <div className="filter-cat filter-session">
          <div className="row">
            <div className="col-md-4">
              <div className="d-flex gap-10">
                <input
                  type="checkbox"
                  value={filter.isSingle}
                  name="isSingle"
                  checked={filter.isSingle}
                  className="filter-check"
                  onClick={() =>
                    setFilter({ ...filter, isSingle: !filter.isSingle })
                  }
                />
                <h3>Single Session</h3>
              </div>
            </div>
            {filter.isSingle && (
              <div className="col-md-8">
                <div className="show-wrap">
                  <div className="price-wrapper">
                    <p>Rs.{numberWithCommas(filter?.singleAmount[0])}</p>
                  </div>
                  <div className="price-wrapper">
                    <p>Rs.{numberWithCommas(filter?.singleAmount[1])}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          {filter.isSingle && (
            <RangeSlider
              values={filter.singleAmount}
              min={0}
              max={100000}
              step={1}
              onChange={(values) => updateAmount("singleAmount", values)}
            />
          )}
        </div>
        <div className="filter-cat filter-session">
          <div className="row">
            <div className="col-md-4">
              <div className="d-flex gap-10">
                <input
                  type="checkbox"
                  value={filter.isWeekly}
                  name="isSingle"
                  checked={filter.isWeekly}
                  className="filter-check"
                  onClick={() =>
                    setFilter({ ...filter, isWeekly: !filter.isWeekly })
                  }
                />
                <h3>Weekly Session</h3>
              </div>
            </div>
            {filter.isWeekly && (
              <div className="col-md-8">
                <div className="show-wrap">
                  <div className="price-wrapper">
                    <p>Rs.{numberWithCommas(filter?.weeklyAmount[0])}</p>
                  </div>
                  <div className="price-wrapper">
                    <p>Rs.{numberWithCommas(filter?.weeklyAmount[1])}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          {filter.isWeekly && (
            <RangeSlider
              values={filter.weeklyAmount}
              min={0}
              max={100000}
              step={1}
              onChange={(values) => updateAmount("weeklyAmount", values)}
            />
          )}
        </div>
        <div className="filter-cat filter-session">
          <div className="row">
            <div className="col-md-4">
              <div className="d-flex gap-10">
                <input
                  type="checkbox"
                  value={filter.isMonthly}
                  name="isSingle"
                  checked={filter.isMonthly}
                  className="filter-check"
                  onClick={() =>
                    setFilter({ ...filter, isMonthly: !filter.isMonthly })
                  }
                />
                <h3>Monthly Session</h3>
              </div>
            </div>

            {filter.isMonthly && (
              <div className="col-md-8">
                <div className="show-wrap">
                  <div className="price-wrapper">
                    <p>Rs.{numberWithCommas(filter?.monthlyAmount[0])}</p>
                  </div>
                  <div className="price-wrapper">
                    <p>Rs.{numberWithCommas(filter?.monthlyAmount[1])}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          {filter.isMonthly && (
            <RangeSlider
              values={filter.monthlyAmount}
              min={0}
              max={100000}
              step={1}
              onChange={(values) => updateAmount("monthlyAmount", values)}
            />
          )}
        </div>
        <div className="filter-cat">
          <h3>Categories</h3>
          <div className="form-group input-group mt-2">
            <label className="has-float-label">
              <Multiselect
                options={categoryList}
                hidePlaceholder={true}
                closeOnSelect={false}
                onSelect={(val) => setFilter({ ...filter, categories: val })}
                onRemove={(val) => setFilter({ ...filter, categories: val })}
                selectedValues={filterData.categories}
                displayValue="name"
                className="multi-select-wrapper"
              />
            </label>
          </div>
        </div>
      </div>
      <div className=" mt-4 mb-5">
        <div className=" d-flex justify-content-between align-items-center w-100 p-10 testimonials-wrapper">
          <div>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn"
              onClick={() => appContext.updateModalState()}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary prime-btn"
              data-dismiss="modal"
              onClick={fetchFilterData}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
